
export default {
  scrollToTop: true,
  props: {
    author: {
      type: Object,
      default: null,
    },
    seoAuthorName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      subscriptions: null,
    }
  },
  async fetch() {
    if (this.author) {
      await this.fetchSubscriptions()
    }
  },
  computed: {
    subscriptionsLength() {
      return (
        this.subscriptions?.streams?.length +
        this.subscriptions?.companys?.length +
        this.subscriptions?.users?.length
      )
    },
    isUserHasSubscriptions() {
      return (
        this.subscriptions?.streams?.length ||
        this.subscriptions?.companys?.length ||
        this.subscriptions?.users?.length
      )
    },
  },
  methods: {
    updateSubscription() {
      this.$fetch()
      this.$emit('update-subscription')
    },
    async fetchSubscriptions() {
      this.subscriptions = await this.$axios.$get(
        `/author/${this.author.username}/subscriptions`,
        {
          params: {
            limit: this.subscriptionsLimit,
            offset: this.subscriptionsOffset,
          },
        }
      )
    },
  },
}
